export default __webpack_public_path__ + "static/media/bg_exora_new.1070a0f8.jpg";